/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 19:43:51
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-01-26 19:43:58
 * @FilePath: /knit-web/src/locale/en-US/account.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  account: {
    title: 'Account',
    language: 'Language',
    languageZhCN: '中文',
    languageEnUS: 'English',
    name: 'Name',
    email: 'Email',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    namePlaceholder: 'Please enter name',
    nameRequired: 'Name cannot be empty',
    updateSuccess: 'Update successful',
    updateFailed: 'Update failed',
  },
};
